module.exports = __webpack_public_path__ + "img/merch-3.34ae6893.png";